import pathify from 'vuex-pathify';

export default pathify;

// Modify the default options here
